<script lang="ts" setup>
import { Skeleton } from '@laam/ui/base';
</script>
<template>
	<div class="brands--loader">
		<div
			class="flex h-[56px] w-full bg-white border-b py-md pl-3xl pr-md gap-3xl lg:mt-0 mt-[56px]"
		>
			<Skeleton class="w-full h-full col-span-3 bg-gray-300" />
			<Skeleton class="size-9xl bg-gray-400" />
		</div>
		<div class="gap-md px-3xl py-md flex border-b">
			<Skeleton class="size-8xl rounded-medium bg-gray-800" />
			<Skeleton
				v-for="i in 8"
				:key="i"
				class="size-8xl rounded-medium bg-gray-300"
			/>
		</div>
		<div class="p-3xl">
			<div v-for="i in 5" :key="i">
				<Skeleton class="w-9xl h-9xl bg-gray-100 rounded" />
				<Skeleton
					class="ml-5xl pl-6xl px-3xl mx-3xl my-3xl py-lg block w-[90%] lg:w-fit border-l-2 border-r-0 border-gray-100"
				/>
			</div>
		</div>
	</div>
</template>
